import t from "@common/src/i18n/t";
const routerArr = [
  {
    path: "statement/turnover-list",
    name: "statementTurnoverList",
    component: () => import("../views/statement/turnover-list.vue"),
    meta: {
      title: t("v210831.turnover-statement"),
      menuKey: "statement"
    }
  },
  {
    path: "statement/turnover-view",
    name: "statementTurnoverView",
    component: () => import("../views/statement/turnover-view.vue"),
    meta: {
      title: t("v210831.turnover-analysis"),
      menuKey: "statement"
    }
  },
  {
    path: "statement/customer-list",
    name: "statementCustomerList",
    component: () => import("../views/statement/customer-list.vue"),
    meta: {
      title: t("v210831.customer-information-report"),
      menuKey: "statement"
    }
  },
  {
    path: "statement/customer-view",
    name: "statementCustomerView",
    component: () => import("../views/statement/customer-view.vue"),
    meta: {
      title: t("v210831.customer-analysis"),
      menuKey: "statement"
    }
  },
  {
    path: "statement/market-list",
    name: "statementMarketList",
    component: () => import("../views/statement/market-list.vue"),
    meta: {
      title: t("v210831.tire-sales-report"),
      menuKey: "statement"
    }
  },
  {
    path: "statement/market-view",
    name: "statementMarketView",
    component: () => import("../views/statement/market-view.vue"),
    meta: {
      title: t("v210831.tire-sales-analysis"),
      menuKey: "statement"
    }
  },
  {
    path: "/inventory/index",
    name: "inventoryIndex",
    component: () => import("../views/inventory/inventory-query.vue"),
    meta: {
      title: t("warehouse.inventory-query"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "/inventory/out-warehouse",
    name: "inventoryOutWarehouse",
    component: () => import("../views/inventory/out-warehouse.vue"),
    meta: {
      title: t("warehouse.outbound-manage"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "/inventory/out-warehouse-add",
    name: "outWarehouseAdd",
    component: () => import("../views/inventory/out-warehouse-edit.vue"),
    meta: {
      title: t("v210801.new-out-warehouse-order"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "/inventory/out-warehouse-edit/:id",
    name: "outWarehouseEdit",
    component: () => import("../views/inventory/out-warehouse-edit.vue"),
    meta: {
      title: t("v210801.edit-out-warehouse-order"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "/inventory/out-warehouse-view/:id",
    name: "outWarehouseView",
    component: () => import("../views/inventory/out-warehouse-view.vue"),
    meta: {
      title: t("v210901.delivery-order-details"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "/inventory/in-warehouse",
    name: "inventoryInWarehouse",
    component: () => import("../views/inventory/in-warehouse.vue"),
    meta: {
      title: t("warehouse.inbound-manage"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "/inventory/in-warehouse-add",
    name: "inWarehouseAdd",
    component: () => import("../views/inventory/in-warehouse-edit.vue"),
    meta: {
      title: t("warehouse.add-inbound-order"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "/inventory/in-warehouse-edit/:id",
    name: "inWarehouseEdit",
    component: () => import("../views/inventory/in-warehouse-edit.vue"),
    meta: {
      title: t("warehouse.edit-inbound-order"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "/inventory/in-warehouse-view/:id",
    name: "inWarehouseView",
    component: () => import("../views/inventory/in-warehouse-view.vue"),
    meta: {
      title: t("v210901.warehouse-receipt-details"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "/inventory/inventory-record",
    name: "inventoryRecord",
    component: () => import("../views/inventory/inventory-record.vue"),
    meta: {
      title: t("v210901.issue-/-receipt-query"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/collect-customer",
    name: "collectCustomer",
    component: () => import("../views/marketing/campaign/collect-customer.vue"),
    meta: {
      title: t("v210801.customer-accumulation-activities"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/collect-customer-add",
    name: "collectCustomerAdd",
    component: () => import("../views/marketing/campaign/collect-customer-edit.vue"),
    meta: {
      title: t("v210801.new-customer-accumulation"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/collect-customer-edit/:id",
    name: "collectCustomerEdit",
    component: () => import("../views/marketing/campaign/collect-customer-edit.vue"),
    meta: {
      title: t("v210901.edit-customer-accumulation-activities"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/collect-customer-view/:id",
    name: "collectCustomerView",
    component: () => import("../views/marketing/campaign/collect-customer-view.vue"),
    meta: {
      title: t("v210901.details-of-customer-accumulation-activities"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/send-collect-customer/:id",
    name: "sendCollectCustomer",
    component: () => import("../views/marketing/campaign/send-collect-customer.vue"),
    meta: {
      title: t("v210901.send-customer-accumulation-activities"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/fission-campagin",
    name: "fissionCampagin",
    component: () => import("../views/marketing/campaign/fission-campagin.vue"),
    meta: {
      title: t("v210801.fission-activity"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/fission-send-collect/:id",
    name: "fissionSendCollect",
    component: () => import("../views/marketing/campaign/fission-send-collect.vue"),
    meta: {
      title: t("v210901.send-fission-activity"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/fission-campagin-add",
    name: "fissionCampaginAdd",
    component: () => import("../views/marketing/campaign/fission-campagin-edit.vue"),
    meta: {
      title: t("v210801.new-fission-activity"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/fission-campagin-view/:id",
    name: "fissionCampaginView",
    component: () => import("../views/marketing/campaign/fission-campagin-view.vue"),
    meta: {
      title: t("v210901.fission-activity-detail"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/fission-campagin-add/:id",
    name: "fissionCampaginEdit",
    component: () => import("../views/marketing/campaign/fission-campagin-edit.vue"),
    meta: {
      title: t("v210801.edit-fission-activity"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/fission-analysis/:id",
    name: "fissionAnalysis",
    component: () => import("../views/marketing/campaign/fission-analysis.vue"),
    meta: {
      title: t("v210901.fission-activity-data"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/lottery",
    name: "lottery",
    component: () => import("../views/marketing/campaign/lottery.vue"),
    meta: {
      title: t("v210801.lucky-draw"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/lottery-add",
    name: "lotteryAdd",
    component: () => import("../views/marketing/campaign/lottery-edit.vue"),
    meta: {
      title: t("v210831.new-lucky-draw"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },

  {
    path: "/marketing/campaign/lottery-edit/:id",
    name: "lotteryEdit",
    component: () => import("../views/marketing/campaign/lottery-edit.vue"),
    meta: {
      title: t("v210831.edit-lucky-draw"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/lottery-view/:id",
    name: "lotteryView",
    component: () => import("../views/marketing/campaign/lottery-view.vue"),
    meta: {
      title: t("v210901.raffle-details"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/send-lottery-qualification/:id",
    name: "SendLotteryEntry",
    component: () => import("../views/marketing/campaign/send-lottery-qualification.vue"),
    meta: {
      title: t("v210831.send-lucky-draw"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/collect-analysis/:id",
    name: "CollectCampaignAnalysis",
    component: () => import("../views/marketing/campaign/collect-analysis.vue"),
    meta: {
      title: t("v210901.customer-accumulation-activity-data"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/campaign/lottery-analysis/:id",
    name: "lotteryCampaignAnalysis",
    component: () => import("../views/marketing/campaign/lottery-analysis.vue"),
    meta: {
      title: t("v210901.lottery-activity-data"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/discount-coupon",
    name: "marketingDiscountCoupon",
    component: () => import("../views/marketing/coupon/discount-coupon.vue"),
    meta: {
      title: t("marketing.discount-coupon"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/created-coupon/add",
    name: "marketingCreatedCouponAdd",
    component: () => import("../views/marketing/coupon/created-coupon.vue"),
    meta: {
      title: t("v210801.new-coupon"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/created-coupon/:code",
    name: "marketingCreatedCouponEdit",
    component: () => import("../views/marketing/coupon/created-coupon.vue"),
    meta: {
      title: t("v210831.edit-coupon"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/look-coupon/:activityCode",
    name: "marketingLookCoupon",
    component: () => import("../views/marketing/coupon/look-coupon.vue"),
    meta: {
      title: t("v210831.view-coupons"),
      menuKey: "marketing",
      opMenuKey: "operation"
    }
  },
  {
    path: "/marketing/send-coupon/:activityCode",
    name: "marketingSendCouponTo",
    component: () => import("../views/marketing/coupon/send-coupon.vue"),
    meta: {
      title: t("v210831.issue-coupons"),
      menuKey: "marketing"
    }
  },
  {
    path: "/marketing/coupon-send",
    name: "marketingSendCouponPage",
    component: () => import("../views/marketing/coupon/coupon-send-list.vue"),
    meta: {
      title: t("v210831.coupon-issuance"),
      menuKey: "marketing"
    }
  },
  {
    path: "/test/index",
    name: "testIndex",
    component: () => import("../views/testing/index.vue"),
    meta: {
      title: t("v210901.testing-management"),
      menuKey: "service"
    }
  },
  {
    path: "/test/edit/:id",
    name: "testEdit",
    component: () => import("../views/testing/test-edit.vue"),
    meta: {
      title: t("v210901.Edit-test"),
      menuKey: "service"
    }
  },
  {
    path: "/test/view/:id",
    name: "testView",
    component: () => import("../views/testing/test-view.vue"),
    meta: {
      title: t("v210901.Check-the-test"),
      menuKey: "service"
    }
  },
  {
    path: "/test/add",
    name: "testAdd",
    component: () => import("../views/testing/test-edit.vue"),
    meta: {
      title: t("v210901.The-new-test"),
      menuKey: "service"
    }
  },
  {
    path: "setting/test-items",
    name: "settingTestItems",
    component: () => import("../views/setting/test-items.vue"),
    meta: {
      title: t("v210901.test-item"),
      menuKey: "setting",
      opMenuKey: "operation"
    }
  },
  {
    path: "setting/test-items-add",
    name: "settingTestItemsAdd",
    component: () => import("../views/setting/test-items-edit.vue"),
    meta: {
      title: t("v210901.Add-test-Items"),
      menuKey: "setting",
      opMenuKey: "operation"
    }
  },
  {
    path: "setting/test-items-edit/:id",
    name: "settingTestItemsEdit",
    component: () => import("../views/setting/test-items-edit.vue"),
    meta: {
      title: t("v210901.Edit-test-items"),
      menuKey: "setting",
      opMenuKey: "operation"
    }
  },
  {
    path: "setting/test-items-view/:id",
    name: "settingTestItemsView",
    component: () => import("../views/setting/test-items-view.vue"),
    meta: {
      title: t("v210901.View-test-Items"),
      menuKey: "setting",
      opMenuKey: "operation"
    }
  },
  {
    path: "setting/test-template",
    name: "settingTestTemplate",
    component: () => import("../views/setting/test-template.vue"),
    meta: {
      title: t("v210901.Detection-template"),
      menuKey: "setting",
      opMenuKey: "operation"
    }
  },
  {
    path: "setting/test-template-add",
    name: "settingTestTemplateAdd",
    component: () => import("../views/setting/test-template-edit.vue"),
    meta: {
      title: t("v210901.Adding-Detection-Template"),
      menuKey: "setting",
      opMenuKey: "operation"
    }
  },
  {
    path: "setting/test-template-edit/:id",
    name: "settingTestTemplateEdit",
    component: () => import("../views/setting/test-template-edit.vue"),
    meta: {
      title: t("v210901.Edit-detection-template"),
      menuKey: "setting",
      opMenuKey: "operation"
    }
  },
  {
    path: "setting/test-template-view/:id",
    name: "settingTestTemplateView",
    component: () => import("../views/setting/test-template-view.vue"),
    meta: {
      title: t("v210901.Viewing-detection-Templates"),
      menuKey: "setting",
      opMenuKey: "operation"
    }
  },
  {
    path: "inventory/transfer-warehouse-list",
    name: "TransferWarehouseList",
    component: () => import("../views/inventory/transfer-warehouse/transfer-warehouse-list.vue"),
    meta: {
      title: t("v211030.Print-Template"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "inventory/transfer-warehouse-add",
    name: "TransferWarehouseAdd",
    component: () => import("../views/inventory/transfer-warehouse/transfer-warehouse-edit.vue"),
    meta: {
      title: t("v210.new-stock-transfer-doc"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "inventory/transfer-warehouse-edit/:id",
    name: "TransferWarehouseEdit",
    component: () => import("../views/inventory/transfer-warehouse/transfer-warehouse-edit.vue"),
    meta: {
      title: t("v210.edit-stock-transfer-doc"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "inventory/transfer-warehouse-view/:id",
    name: "TransferInventoryView",
    component: () => import("../views/inventory/transfer-warehouse/transfer-warehouse-view.vue"),
    meta: {
      title: t("v210.details-of-stock-transfer-order"),
      menuKey: "inventory",
      opMenuKey: "operation"
    }
  },
  {
    path: "statement/parts-sales-list",
    name: "PartsSalesList",
    component: () => import("../views/statement/parts-sales-list.vue"),
    meta: {
      title: t("v212.parts-sales-details-query"),
      menuKey: "statement",
      opMenuKey: "operation"
    }
  },
  {
    path: "setting/service",
    name: "service",
    component: () => import("../views/setting/service-items.vue"),
    meta: {
      title: t("v210901.Services-Available"),
      menuKey: "setting"
    }
  },
  {
    path: "setting/service-add",
    name: "settingServiceAdd",
    component: () => import("../views/setting/service-items-edit.vue"),
    meta: {
      title: t("v210901.Adding-service-Items"),
      menuKey: "setting"
    }
  },
  {
    path: "setting/service-edit/:id",
    name: "settingServiceEdit",
    component: () => import("../views/setting/service-items-edit.vue"),
    meta: {
      title: t("v210901.Editing-service-items"),
      menuKey: "setting"
    }
  },
  {
    path: "statement/receipt-report-list",
    name: "statementReceiptChart",
    component: () => import("../views/statement/receipt-list.vue"),
    meta: {
      title: t("v213.collection-doc-report"),
      menuKey: "statement"
    }
  },
  {
    path: "statement/receipt-report-analysis",
    name: "statementReceiptAnalysis",
    component: () => import("../views/statement/receipt-analysis.vue"),
    meta: {
      title: t("v213.collection-doc-analysis"),
      menuKey: "statement"
    }
  },
  {
    path: "statement/purchase-sales-inventory-report",
    name: "InvoicingReport",
    component: () => import("../views/statement/purchase-sales-inventory-report.vue"),
    meta: {
      title: t("v212.invoicing-report"),
      menuKey: "statement",
      opMenuKey: "operation"
    }
  }
];

export default routerArr;
